/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ChatIcon = ({ width = 24, height = 24, hidden = false, title = 'Chat' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M19 14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9.586a1 1 0 0 0-.707.293L6 31.171V29a1 1 0 0 0-1-1H3a1 1 0 0 1-1-1V15a1 1 0 0 1 1-1ZM3 12a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h1v4.793a.5.5 0 0 0 .854.353L10 30h9a3 3 0 0 0 3-3V15a3 3 0 0 0-3-3Z"
    />
    <path
      d="M24 14.6a4.6 4.6 0 0 0-4.6-4.6H12V5a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3h-3v4.793a.5.5 0 0 1-.854.353L24 20Z"
    />
  </svg>`;
};
